import { type FC } from 'react'
import Image from 'next/image'
import { type FloatingAdvertProps } from './FloatingAdvert.interface'
import styles from './FloatingAdvert.module.scss'
import { Icon } from '../Icon/Icon'
import { Button } from '../Button/Button'
import { CloseIcon } from '../Map/MapComponents/buttons'

interface ExtendedFloatingAdvertProps extends FloatingAdvertProps {
  handleCloseAdvert: () => void;
  showAdvert: boolean;
}

export const FloatingAdvert: FC<ExtendedFloatingAdvertProps> = ({
  title,
  description,
  image,
  link,
  handleCloseAdvert,
  showAdvert
}) => showAdvert && (
  <aside className={styles.container}>
    <div className={styles.grid}>
      <div className={styles.image}>
        <Image
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
        />
      </div>
      <div className={styles.body}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>
          {description}
        </p>
        <a
          href={link.link}
          target={link.linkTarget ?? ''}
          className={styles.link}
        >
          <Icon className={styles['link-icon']} name="#arrow-horizontal" />
          {link.children}
        </a>
      </div>
    </div>
    <Button className={styles['close-button']} onClick={handleCloseAdvert}>
      <CloseIcon radius={7} />
    </Button>
  </aside>
)
